import { HomeView } from 'src/sections/home/home-view';

export default function HomePage() {
  return <HomeView />;
}
